import * as colorPicker from '@zag-js/color-picker';

/** Resolves FPL's controlled pointer-up value against the latest local drag frame. */
export function resolveSliderCommit(
  event: unknown,
  controlledColor: colorPicker.Color,
  pendingColor: colorPicker.Color | undefined,
): colorPicker.Color {
  const wasCancelled = typeof event === 'object' && event !== null && 'cancelled' in event && event.cancelled === true;
  return wasCancelled ? controlledColor : (pendingColor ?? controlledColor);
}
